import React from 'react'
import Gobelins from '../../assets/images/logo-gobelins-blanc.svg'
import LogoAfp from '../../assets/images/logo_afp.svg'
import SocialNetwork from '../SocialNetwork'

import './styles.css'

import type { ContextRouter } from 'react-router-dom'

type PropsType = {
  ...ContextRouter,
  PhotographersApp: PhotographersApp,
  DailyItemsApp: DailyItemsApp,
}

type StateType = { 
}

export default class Photographer extends React.Component<PropsType, StateType> {
  
  constructor(props: PropsType) {
    super(props)

    this.mainWrapper = React.createRef();
    
  }

  componentDidMount () {
    setTimeout(() => {
      this.mainWrapper.current.classList.add('slideInUp');
      this.props.CameraApp.setAutomatic(false);
    }, 250);
  }

  closeAbout () {
    this.mainWrapper.current.classList.remove('slideInUp');
    
    setTimeout(() => {
      this.props.returnToArticle();
    }, 500);
  }

  render() {

    return (
      <div ref={this.mainWrapper} className="about-wrapper">
        <img className="logo-about" src="/static/media/logo.cd729881.svg" alt="logo" onClick={() => this.closeAbout()} />
        <div className="btn-container quit-btn" onClick={() => this.closeAbout()}></div>

        <div className="text-wrapper">
          <div>
            <h5 className="small-title">About</h5>
            <p className="about-description">
              Instant is a website that offers a new way to inform, highlighting an important event each day through one photo. It showcases the wealth and beauty of the work of AFP’s photographers and journalists.
              <br /><br />
              This experience was created by students in design and management of interactive innovation at Gobelins:<br />
              design by Julie Ferrieux and Karolina Mikos,<br />
              development by Kevin Leiba and Thanh-Binh Tang, in collaboration with AFP.<br />
            </p>
            <div className="about-icons">
              <img src={Gobelins} alt="gobelins" />
              <img src={LogoAfp} alt="afp" />
            </div>
            <div className="social-networks-about">
              <h5 className="small-title">Share</h5>
              <div className="sn"><SocialNetwork type="twitter" url="http://twitter.com" /></div>
              <div className="sn"><SocialNetwork type="facebook" url="http://facebook.com" /></div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

        


// WEBPACK FOOTER //
// ./src/components/About/index.jsx